import React from "react"
import PropTypes from "prop-types"
import { NOTIFICATION_SECTIONS } from "./adminSettingsData"
import SettingsToggle from "./SettingsToggle"

const NotificationsTab = ({
  preferences,
  onToggle,
  sections = NOTIFICATION_SECTIONS,
  isLoading = false,
  disabled = false,
}) => (
  <div
    className="admin-settings__panel admin-settings__panel--notifications"
    aria-busy={isLoading || undefined}
  >
    {isLoading
      ? Array.from({ length: 2 }).map((_, sectionIndex) => (
          <section
            key={`notif-skeleton-${sectionIndex}`}
            className="admin-settings__notification-section"
          >
            <div className="admin-settings__skeleton admin-settings__skeleton--title" />
            <div className="admin-settings__section-divider" aria-hidden="true" />
            <ul className="admin-settings__notification-list">
              {Array.from({ length: sectionIndex === 0 ? 2 : 1 }).map(
                (__, rowIndex) => (
                  <li
                    key={`notif-skeleton-row-${sectionIndex}-${rowIndex}`}
                    className="admin-settings__notification-row admin-settings__notification-row--skeleton"
                  >
                    <span className="admin-settings__skeleton admin-settings__skeleton--label" />
                    <span className="admin-settings__skeleton admin-settings__skeleton--desc" />
                    <span className="admin-settings__skeleton admin-settings__skeleton--toggle" />
                  </li>
                ),
              )}
            </ul>
          </section>
        ))
      : sections.map(section => (
          <section
            key={section.key}
            className="admin-settings__notification-section"
          >
            <h2 className="admin-settings__section-title">{section.title}</h2>
            <div
              className="admin-settings__section-divider"
              aria-hidden="true"
            />

            <ul className="admin-settings__notification-list">
              {section.items.map(item => (
                <li
                  key={item.key}
                  className="admin-settings__notification-row"
                >
                  <span className="admin-settings__notification-label">
                    {item.label}
                  </span>
                  <span className="admin-settings__notification-description">
                    {item.description}
                  </span>
                  <SettingsToggle
                    label={item.label}
                    checked={Boolean(preferences[item.key])}
                    onChange={next => onToggle(item.key, next)}
                    disabled={disabled}
                  />
                </li>
              ))}
            </ul>
          </section>
        ))}
  </div>
)

NotificationsTab.propTypes = {
  preferences: PropTypes.objectOf(PropTypes.bool).isRequired,
  onToggle: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }),
  ),
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
}

NotificationsTab.defaultProps = {
  sections: NOTIFICATION_SECTIONS,
  isLoading: false,
  disabled: false,
}

export default NotificationsTab
